import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryHotelInfo.js';
import { RichText } from '@synergycms_core/components/generic';
import { Map } from 'immutable';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';

const AvailMainSideSummaryHotelInfo = class AvailMainSideSummaryHotelInfo extends React.Component {
  static displayName = 'AvailMainSideSummaryHotelInfo';

  render() {
    const { config, theme } = this.props,
      {
        hotel,
      } = config;

    const { classes } = theme.styles;

    return (
      <div>
        <div className={classes.hotelFiscalInfoContainer}>
          <RichText dangerouslySetInnerHTML={hotel.get('phone', '')} innerStyle={['roboto11Black400', classes.phoneText].join(' ')} />
          <RichText dangerouslySetInnerHTML={hotel.get('email', '')} innerStyle={['roboto11Black400']} />
          <RichText dangerouslySetInnerHTML={`${hotel.get('address', '')} ${hotel.get('country', '')} ${hotel.get('zip_code', '')}, ${hotel.get('city')}`} innerStyle={['roboto11Black400']} />
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  
  return {
    hotel: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['fullVersion']),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'hotel',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryHotelInfo);
